export default "__VITE_ASSET__4108042d__"